export default __webpack_public_path__ + "static/media/bestVerbatim.40cc2f06.png";